import styled from 'styled-components';
import { getPublicPath } from 'utils/paths';
import {
  color,
  container,
  fontSize,
  fontWeight,
  radius,
  spacing
} from '../../../theme';
import { Heading1 } from '../../shared/Typography';

export const StyledHero = styled.div`
  background-image: ${() =>
    ` url('${getPublicPath(
      '/images/bringYourOwnTeam/space-ship-tail.svg'
    )}'), linear-gradient(
126deg,#147092,#147092 10%,#0da1a4 50%,#28cebc 100%,#28cebc 0)`};
  background-repeat: no-repeat, no-repeat;
  background-position: center bottom, bottom;
  padding: ${spacing('xl4')} ${spacing('md')} ${spacing('xl8')};
  position: relative;
  overflow: hidden;

  @media (min-width: ${container('xl')}) {
    background-position: right calc(50% - 29.4rem) bottom -3.3rem, bottom;
    padding-bottom: ${spacing('xl7')};
  }
`;

export const StyledHeroStars = styled.div`
  position: absolute;
  inset: 0;
  background-image: ${() =>
    `url('${getPublicPath('/images/bringYourOwnTeam/estrellas.svg')}')`};
  background-repeat: no-repeat;
  background-position: center top;
`;

export const StyledHeroContainer = styled.div`
  max-width: ${container('xl')};
  margin: auto;
  padding-top: ${spacing('xl5')};
  display: flex;
  flex-direction: column;
  gap: ${spacing('md')};
  z-index: 1;
  position: relative;

  @media (min-width: ${container('xl')}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const StyledHeroText = styled.div`
  max-width: ${container('sm')};
  color: ${color('text_white')};
  font-size: ${fontSize('lg')};
  line-height: 1.4;
`;

export const StyledHeroTitle = styled(Heading1)`
  margin-bottom: ${spacing('lg')};
`;

export const StyledHeroActions = styled.div`
  margin-top: ${spacing('xl3')};
`;

export const StyledHeroImage = styled.div`
  align-self: center;

  &:hover {
    animation: vibrate 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) infinite;
  }

  @keyframes vibrate {
    0% {
      transform: translate(0);
    }
    10% {
      transform: translate(-2px, -2px);
    }
    20% {
      transform: translate(2px, -2px);
    }
    30% {
      transform: translate(-2px, 2px);
    }
    40% {
      transform: translate(2px, 2px);
    }
    50% {
      transform: translate(-2px, -2px);
    }
    60% {
      transform: translate(2px, -2px);
    }
    70% {
      transform: translate(-2px, 2px);
    }
    80% {
      transform: translate(-2px, -2px);
    }
    90% {
      transform: translate(2px, -2px);
    }
    100% {
      transform: translate(0);
    }
  }
`;

export const StyledHeroScroll = styled.a`
  display: none;
  position: absolute;
  bottom: ${spacing('xl4')};
  left: 50%;
  transform: translateX(-50%);
  flex-direction: column;
  align-items: center;
  margin-top: auto;
  padding-top: ${spacing('sm')};
  color: ${color('text_default_inverse')};
  font-size: ${fontSize('xs')};
  font-weight: ${fontWeight('medium')};
  text-transform: uppercase;
  z-index: 1;

  &:hover {
    color: ${color('text_default_inverse')};
    opacity: 0.9;
  }

  @media (min-width: ${container('xl')}) {
    display: flex;
  }
`;

export const StyledHeroScrollMouse = styled.div`
  position: relative;
  height: 2.5rem;
  width: 1.5rem;
  margin-bottom: ${spacing('xs')};
  border-radius: ${radius('full')};
  border: 2px solid;
`;

export const StyledHeroScrollMouseBall = styled.div`
  position: absolute;
  top: calc(${spacing('sm')} - ${spacing('xs2')} / 2 - 2px);
  left: calc(50% - ${spacing('xs2')} / 2);
  width: ${spacing('xs2')};
  height: ${spacing('xs2')};
  border-radius: ${radius('full')};
  background-color: ${color('text_default_inverse')};
  animation: ball 3.5s ease-in-out infinite;

  @keyframes ball {
    0% {
      height: ${spacing('xs2')};
      top: calc(${spacing('sm')} - ${spacing('xs2')} / 2 - 2px);
    }
    30% {
      height: ${spacing('sm')};
      top: calc(${spacing('sm')} - ${spacing('xs2')} / 2 - 2px);
      background-color: ${color('active')};
    }
    50% {
      height: ${spacing('xs2')};
      top: ${spacing('md')};
      background-color: ${color('text_default_inverse')};
    }
    75% {
      height: ${spacing('xs2')};
      top: ${spacing('md')};
    }
    100% {
      top: calc(${spacing('sm')} - ${spacing('xs2')} / 2 - 2px);
    }
  }
`;

export const StyledHeroScrollText = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  strong {
    font-weight: ${fontWeight('black')};
    opacity: 0;
    animation: appear 3.5s ease-in-out infinite;

    @keyframes appear {
      40% {
        opacity: 0;
      }
      50% {
        opacity: 1;
      }
      75% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
  }
`;
